<template>
  <div>
    <!-- 企业 -->
    <el-form-item
      label="企业名称"
      prop="json.user_name"
    >
      <el-input
        style="width:400px"
        type="text"
        v-model="ruleForm.json.user_name"
        autocomplete="off"
        placeholder="请输入企业名称"
      ></el-input>
    </el-form-item>

    <el-form-item
      label="行业细分"
      prop="json.i_id"
    >
      <el-select
        v-model="ruleForm.json.i_id"
        placeholder="请选择行业细分"
        style="width:500px"
      >
        <el-option
          v-for="item in IndustriesList"
          :key="item.id"
          :label="item.name"
          :value="item.name"
        >
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item
      label="部门"
      prop="json.d_id"
    >
      <el-select
        v-model="ruleForm.json.d_id"
        placeholder="请选择部门"
        style="width:500px"
      >
        <el-option
          v-for="item in SectorList"
          :key="item.id"
          :label="item.name"
          :value="item.name"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      label="职位"
      prop="json.p_id"
    >
      <el-select
        v-model="ruleForm.json.p_id"
        placeholder="请选择职位"
        style="width:500px"
      >
        <el-option
          v-for="item in PositionList"
          :key="item.id"
          :label="item.name"
          :value="item.name"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <!-- 所在地区 -->
    <!-- <div> -->
    <!-- <el-form-item 
        label="办公地址"
        prop="json.address"
      >
        <el-input
          type="text"
          v-model="ruleForm.json.address"
          autocomplete="off"
          placeholder="请输入办公地址"
        ></el-input>
      </el-form-item> -->
    <!-- <el-form-item
        label="所在地区"
        prop="enterprise_district_sheng"
      >
        <el-select
          v-model="ruleForm.enterprise_district_sheng"
          placeholder="请选择所在省"
         
        >
          <el-option
            label="请选择所在省"
            value="1"
          ></el-option>
        </el-select>
      </el-form-item>

      <div class="district-right">
        <el-form-item prop="enterprise_district_shi">
          <el-select
            v-model="ruleForm.enterprise_district_shi"
            placeholder="请选择所在市"
            style="width:500px;margin: 30px 0 0 40px;"
          >
            <el-option
              label="请选择所在市"
              value="1"
            ></el-option>
          </el-select>
        </el-form-item> -->
    <!-- </div> -->
  </div>
  </div>
</template> 

<script>
export default {
  name: 'enterprise',
  props: ['ruleForm'],
  data () {
    return {
      options: [],
      IndustriesList: [],//行业
      SectorList: [],//部门
      PositionList: [],//职位
    }
  },
  created () {
    this.getIndustriesList()
    this.getSectorList()
    this.getPositionList()
  },
  methods: {
    //获取行业列表
    async getIndustriesList () {
      const { data: data } = await this.$http.post('cate/list', { type: 7 })
      this.IndustriesList = data.data
    },
    //获取部门列表
    async getSectorList () {
      const { data: data } = await this.$http.post('cate/list', { type: 8 })
      this.SectorList = data.data
    },
    //获取职位列表
    async getPositionList () {
      const { data: data } = await this.$http.post('cate/list', { type: 9 })
      this.PositionList = data.data
    },
  }
}

</script>
<style lang="less" scoped>
.district {
  display: flex;

  .district-right {
    /deep/.el-form-item__error {
      margin-left: 40px;
    }
  }
}
</style>